/// <amd-module name="Build/Admin/Pool/Components/AgentAcquisitionDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import { LegacyComponent } from "VSS/Legacy/Legacy";

import { FwLinks } from "Build/Admin/Common/Constants";

import * as Resources from "Build/Admin/Pool/Resources";

interface IDownloadAgentPlatformInfo {
    prerequisites: string;
    createAgentScript: string;
    configureAgentScript: string;
    runAgentScript: string;
    detailedInstructionsLink: string;
}

export interface IAgentAcquisitionDialogProps {
    onCancel(): void;
}

const legacyComponentLoading: () => JSX.Element = () => <Spinner size={SpinnerSize.large} />;

// These values line up with /DistributedTask/Webplatform/DistributedTaskControls/Components/AgentAcquisitionDialog.tsx
namespace PackagePlatforms {
    export const Windows: string = "windows";
    export const Linux: string = "linux";
    export const Darwin: string = "darwin";
}

export class AgentAcquisitionDialog extends React.PureComponent<IAgentAcquisitionDialogProps> {
    private _platforms: { [key: string]: IDownloadAgentPlatformInfo } = {};

    constructor(props: IAgentAcquisitionDialogProps) {
        super(props);
        this._populatePlatformData();
    }

    public render(): JSX.Element {
        return (
            <Dialog
                onDismiss={this.props.onCancel}
                showCloseButton={true}
                calloutClassName="pipelines-download-agent-dialog"
                calloutContentClassName="pipelines-download-agent-dialog-content"
                titleProps={{ text: Resources.AgentAcquisitionDialogTitle }}
            >
                <LegacyComponent
                    agentAcquisitionGuidances={this._platforms}
                    className="pipelines-download-agent-dialog-host"
                    wrappedType="LegacyAgentAcquisitionDialog"
                    modules={["DistributedTaskControls/Components/AgentAcquisitionDialog", "VSS/LoaderPlugins/Css!Site"]}
                    loadingComponent={legacyComponentLoading}
                />
            </Dialog>
        );
    }

    private _populatePlatformData(): void {
        this._platforms[PackagePlatforms.Windows] = {
            prerequisites: FwLinks.PrerequisitesLinkWindows,
            createAgentScript: Resources.DownloadAgentWindowsMarkdown,
            configureAgentScript: Resources.ConfigureAgentWindowsMarkdown,
            runAgentScript: Resources.RunAgentWindowsMarkdown,
            detailedInstructionsLink: FwLinks.DetailedInstructionsLinkWindows
        };

        this._platforms[PackagePlatforms.Linux] = {
            prerequisites: FwLinks.PrerequisitesLinkLinux,
            createAgentScript: Resources.DownloadAgentLinuxMarkdown,
            configureAgentScript: Resources.ConfigureAgentLinuxMarkdown,
            runAgentScript: Resources.RunAgentLinuxMarkdown,
            detailedInstructionsLink: FwLinks.DetailedInstructionsLinkLinux
        };

        this._platforms[PackagePlatforms.Darwin] = {
            prerequisites: FwLinks.PrerequisitesLinkDarwin,
            createAgentScript: Resources.DownloadAgentDarwinMarkdown,
            configureAgentScript: Resources.ConfigureAgentDarwinMarkdown,
            runAgentScript: Resources.RunAgentDarwinMarkdown,
            detailedInstructionsLink: FwLinks.DetailedInstructionsLinkDarwin
        };
    }
}
